import { render, staticRenderFns } from "./ItemSistema.vue?vue&type=template&id=15c819a0"
import script from "./ItemSistema.vue?vue&type=script&lang=js"
export * from "./ItemSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports